<template>
  <div>
    <JetDialogModal
      :show="modalOpen"
      ref="modal"
      @close="modalClose"
    >
      <template #title>
        <h2>Use Template</h2>
      </template>
      <template #content>
        <div class="py-2">
          <label class="block text-gray-700">Select a Template</label>
            <multiselect 
                v-model="selectedTemplate"
                :options="templates"
                label="name"
                placeholder="Select a template"
                select-label=""
                deselect-label=""
            />
        </div>
      </template>
      <template #footer>
        <button class="mr-4" @click="modalClose">
          Cancel
        </button>
        <JetSecondaryButton @click="useTemplate" class="px-2 py-1 text-xs">
          Use Template
        </JetSecondaryButton>
      </template>
    </JetDialogModal>

    <button
      class="text-xs sm:text-sm cursor-pointer px-4 py-2 bg-gray-100 rounded-full hover:bg-gray-300 focus:outline-none"
      type="button"
      @click.prevent="modalOpen = true"
    ><font-awesome-icon :icon="['far', 'clipboard-list']" />
      Use Template
    </button>
  </div>
</template>

<script>
import JetDialogModal from "../Jetstream/DialogModal";
import JetSecondaryButton from "../Jetstream/SecondaryButton";
import axios from "axios";

export default {
    emits: ['use-template'],
  components: {
    JetDialogModal,
    JetSecondaryButton,
  },
  data() {
    return {
      modalOpen: false,
      selectedTemplate: null,
      templates: [], // Saving data in an array to hold template names fetched from the database
    };
  },
  methods: {
    async getTemplates() {
      try {
        const response = await axios.get('/api/template/names');
        this.templates = response.data.templates;
      } catch (error) {
        console.error('Error fetching template names:', error);
      }
    },
    useTemplate() {
      if (this.selectedTemplate) {
        this.$emit("use-template", this.selectedTemplate);
        this.modalClose();
      }
    },
    modalClose() {
      this.modalOpen = false;
    },
  },
  mounted() {
    this.getTemplates();
  },
};
</script>

